module.exports = __webpack_public_path__ + "img/slash.1c1cbd49.svg";